const inlineFilterItems = [
  {
    id: 'all',
    label: "Semua",
  },
  {
    id: "DRAFT",
    label: "Draf",
  },
  {
    id: "ISSUED",
    label: "Terbit",
  },
]

export default inlineFilterItems